<select class="common-text-box" id="{{formControlFieldName}}" aria-label="{{formControlFieldName}}"
  formControlName="{{formControlFieldName}}" placeholder="{{placeholder}}" (change)="sendToParent($event.target.value)"
  [ngClass]="{
    'nr-err-border': (
      formGroup.get(formControlFieldName).touched && (
      formGroup.get(formControlFieldName).hasError('required') || 
      formGroup.get(formControlFieldName).hasError('select') ))
  }">

  <option *ngIf="defaultValue" value="" [disabled]="disable">{{placeholder ? placeholder : 'Select'}}</option>

  <ng-container *ngIf="displayOptionFor === 'default'">
    <option *ngFor="let x of options" [disabled]="disable" [value]="x[key]">{{x[keyValue]}}</option>
  </ng-container>

  <ng-container *ngIf="displayOptionFor === 'modelValues'">
    <option *ngFor="let x of options" [disabled]="disable" [ngValue]="x">{{keyValue === "" ? x : x[keyValue]}}</option>
  </ng-container>

</select>